import axios from 'axios';
import fi_archive_grey from './../assets/img/fi_archive_created.svg';
import fi_archive_yellow from './../assets/img/fi_archive_approved.svg';
import fi_archive_green from './../assets/img/fi_archive_completed.svg';
import fi_archive_red from './../assets/img/fi_archive_rejected.svg';
import fi_archive_blue from './../assets/img/fi_archive_picked.svg';
import moment from 'moment';

export const getFormattedResponse = (data) => {
  if (!data) {
    return {
      list: [],
      columns: [],
      limit: 10,
      pageSize: 10,
      page: 1,
      totalDocs: 0,
      rest: {},
      raw: data,
    };
  }
  const { result = {} } = data;
  const { docs = [], meta = {}, limit = 10, page = 1, totalDocs = 0, ...rest } = result;

  const list = docs.map((item) => {
    const itemObject = {};
    for (const key in item) {
      let value = item.hasOwnProperty(key) ? item[key] : null;
      if (value && meta?.[key]?.enum_dictionary?.hasOwnProperty(value)) {
        value = meta[key].enum_dictionary[value];
      } else if (value && meta?.[key]?.enumDictionary?.hasOwnProperty(value)) {
        value = meta[key].enumDictionary[value];
      } else if (key === 'endDate' || key === 'startDate') {
        value = moment(value).format('YYYY-MM-DD');
      }
      itemObject[key] = value;
    }
    return itemObject;
  });
  const columns = [];
  // const INVALID_INSTANCES = ["array", "object"];
  const INVALID_INSTANCES = ['object'];

  for (const key in meta) {
    if (meta.hasOwnProperty(key) && !INVALID_INSTANCES.includes(meta[key].instance)) {
      columns.push({
        ...meta[key],
        dataIndex: key,
        title: meta[key]?.name ?? '-',
        show: true,
      });
    }
  }

  rest.totalDocs = totalDocs;
  rest.limit = limit;
  return {
    list,
    columns,
    limit,
    pageSize: limit,
    page,
    totalDocs,
    rest,
    raw: data,
  };
  // for (const key in meta) {
  //   if (meta.hasOwnProperty(key)) {
  //     columns.push({
  //       ...meta[key],
  //       dataIndex: key,
  //       title: meta[key]?.name ?? "-",
  //     });
  //   }
  // }
  // return {
  //   list,
  //   columns,
  //   rest,
  //   raw: data,
  // };
};
export const isNumberInput = (value) => {
  const re = /^[0-9\b]+$/;
  return value === '' || re.test(value);
};

export const capitalize = (string) => {
  if (typeof string === 'string' && string.length) {
    return `${string[0].toUpperCase()}${string.substring(1).toLowerCase()}`;
  } else {
    return string;
  }
};

export const uploadFile = async (file, path = '', unlimited = false, prefix = 'image') => {
  const fileObject = file.originFileObj ?? file;

  let folderPath = '';
  if (path) {
    folderPath = `/${path}`;
  }

  if (unlimited) {
    try {
      const data = {
        ContentType: file?.originFileObj?.type ?? file?.type,
        FileName: file?.originFileObj?.name ?? file?.name,
        prefix,
        useFileName: false,
      };
      const res = await axios({
        method: 'post',
        url: `${process.env.REACT_APP_UPLOAD_URL}/geturl/v1${folderPath}`,
        data,
        headers: {
          Authorization: `${process.env.REACT_APP_STORAGE_PREFIX} ${localStorage.getItem('token')}`,
        },
      });
      const uploadUrl = res?.data?.result?.uploadUrl ?? '';

      // const buffer = await (file?.originFileObj?.arrayBuffer?.() ?? file?.arrayBuffer?.());
      // // Get a byte array for that buffer
      // const bytes = new Uint8Array(buffer);
      // // Show it as hex text
      // const lines = [];
      // let line = [];
      // bytes.forEach((byte, index) => {
      // 	const hex = byte.toString(16).padStart(2, "0");
      // 	line.push(hex);
      // 	if (index % 16 === 15) {
      // 		lines.push(line.join(" "));
      // 		line = [];
      // 	}
      // });

      const uploadResponse = await axios({
        url: uploadUrl,
        method: 'put',
        headers: {
          'Content-Type': 'application/pdf',
        },
        noAuthorization: true,
        data: file?.originFileObj ?? file,
      });

      const fileUrl = `https://${res?.data?.result?.baseURL ?? ''}/${
        res?.data?.result?.Path ?? ''
      }`;

      if (uploadResponse.status === 200) {
        return fileUrl;
      }
      return '';
    } catch (e) {
      console.error('File Upload: ', e);
    }
    return '';
  } else {
    const formData = new FormData();
    formData.append('file', fileObject);

    const res = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_UPLOAD_URL}/p/v1${folderPath}?prefix=${prefix}&useFileName=false`,
      data: formData,
      headers: {
        Authorization: `${process.env.REACT_APP_STORAGE_PREFIX} ${localStorage.getItem('token')}`,
      },
    });
    return `https://${res?.data?.result?.[0]?.baseURL ?? ''}/${res?.data?.result?.[0]?.Path ?? ''}`;
  }
};

export const handleFormFileUpload = (files, path, unlimited, prefix) => {
  return new Promise(async (resolve) => {
    try {
      if (!files.length && files) {
        resolve(uploadFile(files, path, unlimited, prefix));
      } else if (files.length > 1) {
        const urls = Promise.all(
          Array.from(files).map(async (file) => {
            return uploadFile(file, path, unlimited, prefix);
          })
        );
        resolve(urls);
      } else {
        resolve(uploadFile(files[0], path, unlimited, prefix));
      }
    } catch (err) {
      resolve('');
    }
  });
};

export const getObjectFromArray = (array, key, identifier = 'key') => {
  if (!Array.isArray(array)) {
    return null;
  }
  for (const element of array) {
    if (element[identifier] === key) {
      return element;
    }
  }
  return null;
};

export const imageUpload = async (file, folderName = 'image') => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const res = await axios({
      method: 'post',
      url: `${
        process.env.REACT_APP_STORAGE_URL
      }/upload/merchant/${folderName}?fileName=imageCover${Date.now()}&uid=${Date.now()}`,
      data: formData,
    });
    return res?.data?.result?.location ?? '';
  } catch (e) {
    console.error(`Image Upload (${folderName}/${file?.name}): `, e);
    return '';
  }
};

/**
 * Захиалгын төлвийн өнгө.
 * Төлвийн badge-үүдтэй (orders/Status.less, orderDelivery/List/Style.less) ижил
 * палетт: цэнхэр — шинэ, цайвар цэнхэр — боловсруулж байна, нил — баталгаажсан,
 * шар/хүрэн шар — хүлээгдэж байна/хүргэлт, ногоон — дууссан, улаан — цуцлагдсан.
 */
export const getOrderStatusColor = (status) => {
  const BLUE = '#2FA1D9';
  const LIGHT_BLUE = '#53B1FD';
  const PURPLE = '#7A5AF8';
  const AMBER = '#F79009';
  const ORANGE = '#FD853A';
  const GREEN = '#17B26A';
  const RED = '#F04438';
  const GREY = '#98A2B3';

  const statuses = {
    created: BLUE,
    confirmed: PURPLE,
    approved: PURPLE,
    driverassigned: PURPLE,
    reserved: LIGHT_BLUE,
    picked: LIGHT_BLUE,
    received: LIGHT_BLUE,
    whreceiver: LIGHT_BLUE,
    whpicker: LIGHT_BLUE,
    'whpicker-store': LIGHT_BLUE,
    collector: LIGHT_BLUE,
    sorter: LIGHT_BLUE,
    bthdriver: LIGHT_BLUE,
    invcontrol: LIGHT_BLUE,
    partialcomplete: AMBER,
    partialdelivered: AMBER,
    returned: AMBER,
    delivery: ORANGE,
    partialdelivery: ORANGE,
    dispatcher: ORANGE,
    hvdriver: ORANGE,
    pdriver: ORANGE,
    picker: ORANGE,
    ordertaken: ORANGE,
    completed: GREEN,
    delivered: GREEN,
    procured: GREEN,
    rejected: RED,
    deleted: RED,
    canceled: RED,
  };

  return statuses[`${(status ?? '').toLowerCase()}`] ?? GREY;
};

export const getOrderStatusImg = (status) => {
  const imgs = {
    created: fi_archive_grey,
    approved: fi_archive_yellow,
    rejected: fi_archive_red,
    picked: fi_archive_blue,
    received: fi_archive_blue,
    partialcomplete: fi_archive_blue,
    completed: fi_archive_green,
    partialdelivery: fi_archive_blue,
    delivery: fi_archive_blue,
    partialdelivered: fi_archive_blue,
    delivered: fi_archive_green,
    deleted: fi_archive_red,
    hvdriver: fi_archive_blue,
    whreceiver: fi_archive_blue,
    whpicker: fi_archive_blue,
    'whpicker-store': fi_archive_blue,
    collector: fi_archive_blue,
    sorter: fi_archive_blue,
    bthdriver: fi_archive_blue,
    dispatcher: fi_archive_blue,
    pdriver: fi_archive_blue,
    picker: fi_archive_blue,
    invcontrol: fi_archive_blue,
  };

  return imgs[`${(status ?? '').toLowerCase()}`] ?? fi_archive_grey;
};

export const getOrderStatus = (enumDictionary = {}, status = '') => {
  for (const key in enumDictionary || {}) {
    if (key.toLowerCase() === (status ?? '').toLowerCase()) return enumDictionary[key];
  }
  return status;
};

export const clearObjFields = (obj = {}) => {
  let res = {};
  for (const key in obj) {
    if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
      res[key] = obj[key];
    }
  }

  return res;
};

export const getObjectByKey = (array = [], key = null, identifier = 'key') => {
  if (key) {
    for (const element of array) {
      if (element[identifier] === key) {
        return element;
      }
    }
  }
  return null;
};

export const sizeEnumDictionary = {
  mm: 'мм',
  cm: 'см',
  m: 'м',
};

export const getProductSizeOptions = () => {
  const options = [];
  for (const key in sizeEnumDictionary) {
    if (Object.hasOwnProperty.call(sizeEnumDictionary, key)) {
      options.push({
        label: sizeEnumDictionary[key],
        value: key,
      });
    }
  }
  return options;
};

export const weightEnumDictionary = {
  g: 'гр',
  kg: 'кг',
};

export const getProductWeightOptions = () => {
  const options = [];
  for (const key in weightEnumDictionary) {
    if (Object.hasOwnProperty.call(weightEnumDictionary, key)) {
      options.push({
        label: weightEnumDictionary[key],
        value: key,
      });
    }
  }
  return options;
};

export const commonRegExp = {
  /*
   * 0-ээс их дурын тоо (бутархай ч байж болно).
   *
   * Өмнө нь эхний хэсэг нь `0*`-ын оронд `1*`/`1+` байсан тул "0."-оор эхэлсэн
   * БҮХ утга (0.001, 0.1, 0.5) татгалзагддаг байсан. Сервер тал жинг үргэлж кг
   * рүү хөрвүүлж хадгалдаг (1 гр → 0.001 кг) учир засах хуудсанд ийм утга
   * ирэхэд бараа хадгалагдахаа больдог байв.
   */
  greaterThanZero: '^(0*[1-9][0-9]*(\\.[0-9]+)?|0*\\.[0-9]*[1-9][0-9]*)$',
  greaterThanFloat: '^(0*[1-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$',
  registrationNumber: '^[\u0400-\u04FF]{2}[0-9]{8}$',
  orgRegistrationNumber: '^[0-9]{7}$',
  phoneNumber: '^[0-9]{8}$',
};

export const isJSON = (value) => {
  try {
    JSON.parse(value);
    return true;
  } catch (error) {
    return false;
  }
};

export const findObjKeyFromValue = (value, object = {}) => {
  for (const key in object) {
    if (Object.hasOwnProperty.call(object, key)) {
      const element = object[key];
      if (element === value) return key;
    }
  }
};
